// @ts-strict-ignore
import { Injectable, ViewContainerRef } from '@angular/core';
import { SohoModalDialogRef, SohoModalDialogService } from 'ids-enterprise-ng';
import { Observable } from 'rxjs';
import { LMLoginComponent } from '@login/lm-login.component';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';

export enum LoginDialogStatus {
  RESPONSE_CANCEL = 0,
  RESPONSE_OK
}

export interface LoginResult {
  status: LoginDialogStatus;
  userName: string;
  password: string;
}

@Injectable()
export class LMLoginService {

  constructor(
    private sohoModalDialogService: SohoModalDialogService,
    private lmLoggerService: LMLoggerService,
    private lmUniqueIdService: LMUniqueIdService
  ) {
  }

  /**
   * Prompt login dialog
   * @param viewContainerRef
   *
   * @return Observable<any>
   */
  public promptLoginDialog(placeholder: ViewContainerRef): Observable<any> {
    const login: Observable<LoginResult> = new Observable<LoginResult>(observer => {
      let loginComponent: LMLoginComponent;
      let dialog: SohoModalDialogRef<any>;
      const dialogId = 'PromptLogin';

      // Build the buttons array
      // Todo: Button text, title translation.
      const buttons = [
        // TODO: The button default disables the button. A bug in controls?
        // TODO: use LMDialogButtonKey and Soho.Locale.translate
        // tslint:disable-next-line - shadowed variable e
        {
          id: this.lmUniqueIdService.uniqueId([dialogId, 'SUBMIT']),
          text: 'SUBMIT',
          click: (e, modal) => {
            this.lmLoggerService.log('User Name: ' + loginComponent.getUserName() + ' Password: ' + loginComponent.getPassword());
            dialog.close(<LoginResult>{
              status:   LoginDialogStatus.RESPONSE_OK,
              userName: loginComponent.getUserName(),
              password: loginComponent.getPassword()
            });
          },
          isDefault: true
        }
      ];
      dialog = this.sohoModalDialogService
        .modal(LMLoginComponent, placeholder, {fullsize: 'responsive'})
        .buttons(buttons)
        .title('')
        .isAlert(false)
        .open()
        .apply((loginForm: LMLoginComponent) => {
          loginComponent = loginForm;
        })
        .afterClose(result => {
          observer.next(result);
          observer.complete();
        });
    });
    return login;
  }
}
